
export const WorkflowStep = Object.freeze({

    NONE:   { id: "NONE", name: "None", color: "black", backgroundColor: "lightyellow", transitions: 
      [
        {status: "PENDING", roles: ["Inspector"]}
      ]
    },
    PENDING:  { id: "PENDING", name: "Pending Approval", isDefault: true, color: "black", backgroundColor: "yellow", transitions: 
      [
        {status: "APPROVED", roles: ["Manager"]},
        {status: "REJECTED", roles: ["Manager"]}
      ]
    },
    APPROVED: { id: "APPROVED", name: "Approved", color: "yellow", backgroundColor: "lightgreen", transitions: 
      [
        {status: "PENDING", roles: ["Manager"]},
        {status: "REJECTED", roles: ["Manager"]}
      ]
    },
    REJECTED: { id: "REJECTED", name: "Rejected", color: "red", backgroundColor: "lightyellow", transitions: 
      [
        {status: "PENDING", roles: ["Manager"]},
        {status: "APPROVED", roles: ["Manager"]}
      ]
    }
  });

export function getWorkflowStatusForegroundColor(workflowStep)
{
    if (!(workflowStep in WorkflowStep)) return "red";
    return WorkflowStep[workflowStep].color;
}

export function getWorkflowStatusBackgroundColor(workflowStep)
{
    if (!(workflowStep in WorkflowStatus)) return "lightyellow";
    return WorkflowStatus[workflowStatus].backgroundColor;
}



